import { useQuery } from '@tanstack/react-query';
import { getFuelingService } from '../../api/fueling-service.ts';
import { normalizeNulls } from '../../utils/normalizeNulls.ts';

export default function useFuelingService(
  serviceId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['fuelingServices', serviceId],
    queryFn: async () => {
      return await getFuelingService(serviceId);
    },
    select: normalizeNulls,
    enabled: !!serviceId && (options?.enabled ?? true),
  });
}
